var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofphn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 10C1.66675 6.46447 1.66675 4.6967 2.88714 3.59835C4.10752 2.5 6.07171 2.5 10.0001 2.5C13.9284 2.5 15.8927 2.5 17.113 3.59835C18.3334 4.6967 18.3334 6.46447 18.3334 10C18.3334 13.5355 18.3334 15.3033 17.113 16.4017C15.8927 17.5 13.9284 17.5 10.0001 17.5C6.07171 17.5 4.10752 17.5 2.88714 16.4017C1.66675 15.3033 1.66675 13.5355 1.66675 10Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 13.75C5.17367 11.5991 8.92691 11.4576 10.0001 13.75M8.75008 7.91667C8.75008 8.83717 8.00389 9.58333 7.08341 9.58333C6.16294 9.58333 5.41675 8.83717 5.41675 7.91667C5.41675 6.99619 6.16294 6.25 7.08341 6.25C8.00389 6.25 8.75008 6.99619 8.75008 7.91667Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33325H15.8333",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667H15.8333",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofphn);
export default __webpack_public_path__ + "static/media/proofphn.af679ac628ea1dfe883c9fd0962a530d.svg";
export { ForwardRef as ReactComponent };